export default "__VITE_ASSET__772d2f1f__"